<template>
    <main
        class="flex min-h-screen flex-col overflow-x-clip"
        :data-page-type="pageType"
    >
        <div
            data-nav-wrapper
            class="sticky top-0 z-50"
        >
            <div
                class="inset-x-0 top-0 transition-all duration-300"
                :class="{
                    'rounded-card-lg m-3 overflow-hidden': bannerHasBorder && !hasScrolled,
                }"
            >
                <div
                    :class="{
                        hidden: hasScrolled,
                    }"
                >
                    <SecondaryNavigation />
                </div>
                <Navigation />
            </div>
        </div>

        <slot />

        <div class="mt-auto">
            <Footer />
        </div>
    </main>
</template>

<script setup>
    const { bannerHasBorder, pageType, hasScrolled } = storeToRefs(useGlobalStore())
</script>
